import React from 'react'
import Wrapper from '../../helpers/Wrapper'

function DetailsSke() {
    return (
        <div className='w-full mt-8'>
            <Wrapper>
                <div className='w-24 h-4 rounded bg-gray-100 animate-pulse mb-2' />
                <div className="flex flex-col gap-8 lg:flex-row gap-y-3">
                    {/* Images */}
                    <div className="w-full flex flex-col gap-4">
                        {/*  */}
                        <div className="relative pt-[100%]">
                            <div
                                className="w-full h-full absolute top-0 left-0 right-0 
                                 bottom-0 bg-gray-100 animate-pulse">
                            </div>
                        </div>
                        {/*  */}
                        <div className="flex items-center"></div>
                    </div>

                    {/* Details */}
                    <div className="w-full space-y-3">
                        <div className="w-10 h-4 rounded-full bg-gray-100 animate-pulse"></div>
                        <div className="w-full">
                            <div className="w-full h-14 rounded bg-gray-100 animate-pulse"></div>
                            <div className="flex items-center gap-2">
                                <div className='w-24 h-10 rounded bg-gray-100 animate-pulse mt-1' />
                                <div className='w-20 h-7 rounded bg-gray-100 animate-pulse mt-1' />
                            </div>
                        </div>

                        <div className="w-full h-16 rounded bg-gray-100 animate-pulse"></div>

                        <div className="flex items-center gap-1.5">
                            <div className='w-10 h-10 rounded-full bg-gray-100 animate-pulse mt-1' />
                            <div className='w-10 h-10 rounded-full bg-gray-100 animate-pulse mt-1' />
                            <div className='w-10 h-10 rounded-full bg-gray-100 animate-pulse mt-1' />
                        </div>

                        <div className="flex items-center gap-1.5">
                            <div className='w-10 h-10 rounded bg-gray-100 animate-pulse mt-1' />
                            <div className='w-10 h-10 rounded bg-gray-100 animate-pulse mt-1' />
                            <div className='w-10 h-10 rounded bg-gray-100 animate-pulse mt-1' />
                        </div>

                        <div className="w-full h-12 rounded bg-gray-100 animate-pulse"></div>

                        <div className="flex items-center gap-1.5">
                            <div className='w-[30%] h-10 rounded-full bg-gray-100 animate-pulse mt-1' />
                            <div className='w-[90%] h-10 rounded-full bg-gray-100 animate-pulse mt-1' />
                        </div>

                        <div className='w-full h-12 rounded-full bg-gray-100 animate-pulse mt-1' />
                    </div>
                </div>
            </Wrapper>
        </div>
    )
}

export default DetailsSke